import axios from "axios";


export const apiGetSettings = () => axios.get("/api/settings")

export const apiSetSettings = (maxDayAfter?: number, maxDayBefore?: number) =>
    axios.post(`/api/settings`, { maxDayAfter, maxDayBefore })

